import useToggle from 'react-use/lib/useToggle';

import { Patient, PatientEntitlement } from '@dreryk/egabinet-patient-frontend-api';

import { dispatchSnackbarPositiveEvent, EditIcon, Link } from '@dreryk/react-components';

import { patientEntitlementsTranslationKeys } from '../../translations';

import { OnPatientEntitlementDocumentUpdated } from './PatientEntitlementUpdateForm.types';
import { PatientEntitlementUpdateModal } from './PatientEntitlementUpdateModal';

type PatientEntitlementUpdateIconProps = {
   readonly patientId: Patient['id'];
   readonly patientEntitlement: PatientEntitlement;
   readonly onPatientEntitlementDocumentUpdated: OnPatientEntitlementDocumentUpdated;
};

export const PatientEntitlementUpdateIcon = (props: PatientEntitlementUpdateIconProps): JSX.Element => {
   const [modalUpdateVisible, toggleModalUpdateVisible] = useToggle(false);

   const handlePatientEntitlementDocumentUpdated: OnPatientEntitlementDocumentUpdated = () => {
      toggleModalUpdateVisible(false);
      dispatchSnackbarPositiveEvent(patientEntitlementsTranslationKeys.additionalEntitlementDocumentDataWasSaved);
      props.onPatientEntitlementDocumentUpdated();
   };

   return (
      <>
         <Link testId={'updateEntitlement'} onClick={toggleModalUpdateVisible} icon={<EditIcon />} />
         {modalUpdateVisible ? (
            <PatientEntitlementUpdateModal
               patientId={props.patientId}
               patientEntitlement={props.patientEntitlement}
               onCancel={toggleModalUpdateVisible}
               onPatientEntitlementDocumentUpdated={handlePatientEntitlementDocumentUpdated}
            />
         ) : null}
      </>
   );
};
